export default __webpack_public_path__ + "static/media/riywo.690ae38b.png";